export default {
  common: {
    selfExplanation: "Autoexplicación",
    prompt: "Mensaje",
    dontDisplayAgain: "No mostrar este mensaje nuevamente.",
    continue: "Continuar",
    goBack: "Regresar",

    cantFindTheCode: "No se puede encontrar el código: ",
    noContent: "Sin contenido",

    promptDisabledReopen: "Puede volver a abrirla en la página [Inicio]->[Mi espacio].",

    what: "Qué:",
    why: "Por qué:",
    learn: "Aprender",
    toLearnOpen: "Para obtener más información, abra"
  },
  E1000: {
    topic: "Objetivo",
    content_1_M:
      "Seleccione el objetivo de rendimiento para este proyecto, como un enfriador, una planta de enfriadores o un sistema de calefacción. Las opciones de planta de calefacción y de enfriamiento y calefacción combinados estarán disponibles pronto.",
    content_2_M:
      "Esta selección impulsa el flujo de trabajo de iECM al definir el límite del sistema, las entradas requeridas, la configuración de equipos aplicable y las métricas de rendimiento utilizadas para evaluar oportunidades de mejora."
  },
  E10200: {
    topic: "Perfil",
    content_1_M: "Configure el perfil del proyecto, incluyendo propósito, condiciones de diseño, configuración del enfriador, perfil meteorológico y configuración de bombeo, cuando corresponda.",
    content_2_M:
      "Esta información ayuda a iECM a adaptar el flujo de trabajo, los campos de entrada y la lógica de auditoría energética al objetivo, tipo de sistema y configuración de equipos seleccionados."
  },
  E10300: {
    topic: "Especificaciones de equipos existentes",
    content_1_M: "Ingrese los detalles de los equipos existentes del sitio, incluyendo enfriadores y otros componentes de planta aplicables, según el objetivo seleccionado.",
    content_2_M: "Esto ayuda a iECM a comprender el sistema actual y aplicar los datos de equipo correctos para la auditoría energética y el análisis de modernización."
  },
  E10400: {
    topic: "Observación del sitio",
    content_1_M: "Capture hallazgos clave, recomendaciones, beneficios esperados y fotos de respaldo de la revisión del sitio del cliente.",
    content_2_M: "Estas notas explican por qué se necesita una modernización y refuerzan el caso de negocio para la auditoría energética y la propuesta."
  },
  E10500: {
    topic: "Configuración de línea base",
    content_1_M:
      "Elija la mejor ruta de datos para construir la línea base energética actual del cliente. Use información de carga de enfriamiento o facturas de consumo energético, luego configure los meses de operación y las tarifas eléctricas para periodos pico y fuera de pico.",
    content_2_M: "Esta selección define el flujo de trabajo de línea base mensual y ayuda a iECM a construir el caso de referencia para la auditoría energética y la estimación de ahorro anual."
  },
  E10610: {
    topic: "Línea base mensual",
    content_1_M:
      "Agregue o edite el perfil de operación del mes base del cliente. iECM usa este perfil para estimar las cargas de enfriamiento del resto del año y calcular la potencia mensual del enfriador.",
    content_2_M: "Esto construye una línea base creíble del estado actual para que el ahorro energético anual y el valor de la modernización puedan compararse claramente."
  },
  E10611: {
    topic: "Calendario de operación",
    content_1_M:
      "Defina cuándo opera el sistema del cliente para esta línea base, como días laborables, fines de semana o toda la semana. Los días de operación mensuales se calculan automáticamente.",
    content_2_M: "Los días de operación muestran con qué frecuencia funciona el sistema cada mes y durante el año, formando la base para los cálculos anuales de carga, energía y ahorro."
  },
  E10612: {
    topic: "Horas de operación",
    content_1_M: "Defina el horario de operación de 24 horas del mes base marcando cada hora como pico, fuera de pico o apagado.",
    content_2_M: "Esto vincula la operación del enfriador con el perfil meteorológico apropiado para cada periodo, ayudando a iECM a calcular la carga y la potencia con mayor precisión."
  },
  E10613: {
    topic: "Enfriador de referencia",
    content_1_M: "Seleccione el enfriador del sitio usado durante los periodos pico y fuera de pico, luego elija el modelo proxy de Carrier más cercano para representar su rendimiento.",
    content_2_M: "iECM usa el modelo proxy y las entradas de calibración para simular el rendimiento del enfriador del cliente y calcular la potencia de línea base mensual con mayor precisión."
  },
  E10614: {
    topic: "Carga de operación",
    content_1_M: "Configure el número de enfriadores en funcionamiento cada hora y su relación de carga para el día base. iECM luego calcula la carga de enfriamiento por hora.",
    content_2_M: "Esto ayuda a iECM a construir el perfil anual de carga de enfriamiento y estimar cuántos enfriadores se necesitan bajo diferentes condiciones meteorológicas mensuales."
  },
  E10615: {
    topic: "Carga de enfriamiento mensual",
    content_1_M: "Revise la carga de enfriamiento promedio ponderada de cada mes. El mes base se basa en entradas por hora, mientras que los demás meses son estimados por iECM.",
    content_2_M:
      "Estas cargas mensuales definen la línea base de demanda de enfriamiento usada para estimar la operación del enfriador, el uso de energía y el ahorro en comparación con las soluciones de modernización."
  },
  E10616: {
    topic: "Conteo mensual de enfriadores",
    content_1_M: "Revise el número mínimo de enfriadores requerido para la operación pico y fuera de pico cada mes, según la carga de enfriamiento mensual y la capacidad de enfriadores disponible.",
    content_2_M: "Esto ayuda a iECM a estimar cómo operan los enfriadores existentes durante el año y respalda los cálculos mensuales de potencia y energía de línea base."
  },
  E10617: {
    topic: "Potencia del enfriador",
    content_1_M:
      "Revise la potencia promedio mensual del enfriador para periodos pico y fuera de pico, calculada a partir del modelo proxy del enfriador, la carga de enfriamiento y el conteo de enfriadores.",
    content_2_M: "Este perfil de potencia se usa para estimar el uso de energía del enfriador antes de la modernización y comparar el ahorro frente a las soluciones de modernización."
  },
  E10620: {
    topic: "Línea base mensual",
    content_1_M: "Agregue o edite configuraciones de línea base mensual según los patrones de operación del cliente, como operación en días laborables y fines de semana.",
    content_2_M:
      "Estas líneas base organizan el flujo de trabajo de facturas de servicios y ayudan a iECM a construir la línea base energética actual para comparar el ahorro anual y el valor de la modernización."
  },
  E10621: {
    topic: "Calendario de operación",
    content_1_M:
      "Defina cuándo opera el sistema del cliente para esta línea base, como días laborables, fines de semana o toda la semana. Los días de operación mensuales se calculan automáticamente.",
    content_2_M: "Los días de operación muestran con qué frecuencia funciona el sistema cada mes y durante el año, formando la base para los cálculos anuales de carga, energía y ahorro."
  },
  E10622: {
    topic: "Horas de funcionamiento",
    content_1_M: "Ingrese las horas de funcionamiento diarias para periodos pico y fuera de pico en cada mes, según el horario de operación del cliente.",
    content_2_M: "Esto vincula la operación del enfriador con el perfil meteorológico apropiado para cada periodo, ayudando a iECM a calcular la potencia con mayor precisión."
  },
  E10623: {
    topic: "Enfriador de referencia",
    content_1_M: "Seleccione el enfriador del sitio usado durante los periodos pico y fuera de pico, luego elija el modelo proxy de Carrier más cercano para representar su rendimiento.",
    content_2_M:
      "iECM usa el modelo proxy y las entradas de calibración para simular el rendimiento del enfriador del cliente y calcular la carga de enfriamiento de línea base mensual con mayor precisión."
  },
  E10624: {
    topic: "Consumo de energía",
    content_1_M: "Ingrese el consumo energético mensual del cliente para periodos pico y fuera de pico usando los datos de facturas de servicios.",
    content_2_M:
      "Esto ayuda a iECM a convertir los datos de facturas en una línea base operativa, incluyendo la potencia estimada del enfriador, el conteo de enfriadores requerido y la demanda de carga de enfriamiento."
  },
  E10625: {
    topic: "Potencia del enfriador",
    content_1_M: "Revise la potencia promedio ponderada mensual del enfriador calculada a partir de los datos de facturas de servicios del cliente para periodos pico y fuera de pico.",
    content_2_M: "Esta potencia promedio ponderada se usa para estimar la operación del enfriador, la demanda de carga de enfriamiento y el ahorro en comparación con las soluciones de modernización."
  },
  E10626: {
    topic: "Conteo mensual de enfriadores",
    content_1_M:
      "Revise el número mínimo de enfriadores requerido para la operación pico y fuera de pico cada mes, según la potencia de enfriamiento promedio mensual y la potencia de enfriadores disponible.",
    content_2_M: "Esto ayuda a iECM a estimar cómo operan los enfriadores existentes durante el año y respalda la línea base mensual de carga de enfriamiento y los cálculos de energía."
  },
  E10627: {
    topic: "Carga de enfriamiento mensual",
    content_1_M:
      "Revise la carga de enfriamiento promedio ponderada mensual derivada de los datos de facturas de servicios, el rendimiento del enfriador proxy, la potencia mensual del enfriador y el conteo de enfriadores.",
    content_2_M:
      "Este perfil de carga de enfriamiento representa la misma demanda del edificio antes y después de la modernización, permitiendo una comparación justa entre los equipos actuales y propuestos."
  },
  E10628: {
    topic: "Potencia auxiliar",
    content_1_M: "Ingrese la potencia de operación promedio ponderada real (kW) de equipos auxiliares, como bombas y torres de enfriamiento, durante periodos pico y fuera de pico.",
    content_2_M: "Esto ayuda a iECM a incluir el uso de energía de los equipos auxiliares en la línea base actual y calcular el uso total de energía antes de la modernización con mayor precisión."
  },
  E10700: {
    topic: "Vista previa de línea base",
    content_1_M:
      "Revise y descargue los resultados de la auditoría energética de línea base previa a la modernización, incluyendo la carga de enfriamiento por hora, la potencia estimada y la carga y potencia mensuales por tipo de equipo.",
    content_2_M:
      "Esto confirma los resultados de la línea base previa a la modernización y genera un informe de auditoría energética listo para el cliente antes de que comience el modelado posterior a la modernización."
  },
  E10800: {
    topic: "Configurar condición de operación",
    content_1_M:
      "Seleccione el nuevo tipo de enfriador y configure las condiciones de operación posteriores a la modernización, como la temperatura del agua helada y los ajustes del lado del condensador.",
    content_2_M: "Esto ayuda a iECM a configurar la disposición posterior a la modernización y estimar el rendimiento según el tipo de equipo seleccionado."
  },
  E10900: {
    topic: "Definir nuevo equipo",
    content_1_M:
      "Agregue y defina el nuevo equipo usado en la solución de modernización, incluyendo enfriadores, bombas y torres de enfriamiento cuando corresponda. Cada entrada representa una unidad de equipo.",
    content_2_M: "Defina cada opción de equipo una vez. iECM calcula las cantidades de operación requeridas y las usa para estimar el rendimiento de la modernización, el ahorro energético y el ROI."
  },
  E10901: {
    topic: "e-CAT digital",
    content_1_M: "Elija un nuevo enfriador del e-CAT digital, configure las condiciones de diseño y el precio de venta, y revise su curva de rendimiento.",
    content_2_M:
      "Esto hace que la selección del enfriador sea más rápida y fácil, a la vez que proporciona los datos de rendimiento necesarios para el análisis de modernización y el cálculo de ahorro. El precio de venta unitario se usa para estimar el CAPEX total del proyecto."
  },
  E10902: {
    topic: "Meses agrupados",
    content_1_M:
      "Use los meses agrupados cuando el enfriador deseado no esté disponible en la biblioteca del e-CAT digital. Agrupe meses similares, luego ingrese los detalles del enfriador y los datos de rendimiento de e-CAT.",
    content_2_M:
      "La agrupación de meses reduce las entradas repetidas de e-CAT, mientras que la entrada manual permite a iECM analizar enfriadores personalizados para el análisis de modernización y el cálculo de ahorro. El precio de venta unitario se usa para estimar el CAPEX total."
  },
  E10903: {
    topic: "Bomba",
    content_1_M: "Defina la nueva bomba y vincúlela al enfriador al que dará soporte en la solución de modernización.",
    content_2_M: "Esto ayuda a iECM a modelar correctamente la solución propuesta al emparejar cada bomba con el enfriador en operación apropiado."
  },
  E10904: {
    topic: "Torre de enfriamiento",
    content_1_M: "Defina la nueva torre de enfriamiento y vincúlela al enfriador al que dará soporte en la solución de modernización.",
    content_2_M: "Esto ayuda a iECM a modelar correctamente la solución propuesta al emparejar cada torre de enfriamiento con el enfriador en operación apropiado."
  },
  E11000: {
    topic: "Solución de modernización",
    content_1_M:
      "Revise las soluciones de modernización generadas por iECM, clasifíquelas por eficiencia, ROI o inversión, y complete la configuración requerida para cada opción. Genere el informe ECM o reconfigure una solución para una disposición personalizada.",
    content_2_M: "Esto le ayuda a elegir la propuesta más sólida para el cliente, ajustar el ROI, el VAN y la configuración propuesta, y generar el informe ECM final."
  },
  E12000: {
    topic: "Solución reconfigurada",
    content_1_M: "Configure manualmente una solución de modernización seleccionando el enfriador asociado y la cantidad máxima de funcionamiento para cada línea base y periodo de operación.",
    content_2_M: "Esto le da flexibilidad para adaptar la propuesta cuando la solución generada automáticamente no es la más adecuada para el cliente."
  },
  E11001: {
    topic: "Configuración de modernización",
    content_1_M:
      "Revise la configuración detallada de la solución de modernización, incluyendo la carga de enfriamiento máxima, la capacidad propuesta del enfriador y los conteos mensuales de equipos en funcionamiento.",
    content_2_M: "Esto confirma cómo se dimensiona y opera el sistema propuesto antes de usarse para el análisis financiero y el informe ECM final."
  },
  E11002: {
    topic: "ROI y VAN",
    content_1_M:
      "Revise y actualice el rendimiento financiero del ciclo de vida de la solución, incluyendo ahorro energético, ahorro de costos, ROI, periodo de recuperación y VAN para la planta de enfriadores o el enfriador.",
    content_2_M: "Esto muestra al cliente cómo la solución mejora la eficiencia, reduce el costo operativo y ofrece valor financiero a largo plazo, incluyendo ROI y VAN."
  },
  E11003: {
    topic: "Detalles de equipos propuestos",
    content_1_M: "Defina el alcance y la configuración detallada de la modernización seleccionando qué equipos existentes permanecerán y qué equipos nuevos los reemplazarán.",
    content_2_M: "Esto aclara los cambios de equipos propuestos y ayuda a crear un plan de modernización e informe ECM completos y listos para el cliente."
  },
  E11004: {
    topic: "Configuración propuesta",
    content_1_M: "Ingrese los supuestos de análisis, los detalles del sistema y las medidas de conservación de energía a incluir en el informe ECM final.",
    content_2_M: "Esto ayuda a crear un informe completo y listo para el cliente que explica claramente la base de la modernización, las medidas propuestas y el valor esperado."
  },

  // HEATING
  E2000: {
    topic: "Objetivo",
    content_1_M:
      "Seleccione el objetivo de rendimiento del proyecto. Indique si la evaluación abarca un solo enfriador, una planta de enfriadores o un sistema de calefacción. Próximamente estarán disponibles las opciones de modernización con bomba de calor y de planta integrada de refrigeración y calefacción.",
    content_2_M:
      "Esta selección guía el resto del flujo de trabajo de iECM Spec Builder. Determina los límites del sistema, los datos de usuario requeridos, la configuración de equipos aplicable y los indicadores de rendimiento utilizados para evaluar oportunidades de mejora."
  },
  E20200: {
    topic: "Perfil",
    content_1_M:
      "Introduzca la información básica del proyecto y las hipótesis de diseño, incluidos el propósito, la ubicación, los datos meteorológicos, la aplicación de calefacción, las condiciones de diseño y la configuración del sistema.",
    content_2_M: "Estos datos permiten que iECM Spec Builder adapte el flujo de trabajo y los cálculos de calefacción al emplazamiento, el clima, la aplicación y el sistema existente."
  },
  E20300: {
    topic: "Especificaciones de los equipos existentes",
    content_1_M:
      "Añada los equipos de calefacción existentes e introduzca las especificaciones principales de cada unidad, incluidos el tipo de equipo, la capacidad, la cantidad, la fuente de combustible o energía y los datos de eficiencia.",
    content_2_M: "Esta información define el sistema de calefacción actual y proporciona los datos necesarios para establecer la línea base y evaluar las opciones de sustitución."
  },
  E20400: {
    topic: "Observación del emplazamiento",
    content_1_M:
      "Registre los hallazgos del emplazamiento, los problemas observados, las recomendaciones, los beneficios esperados y las fotografías de apoyo obtenidas durante la revisión del sitio del cliente.",
    content_2_M: "Las observaciones del emplazamiento explican las razones prácticas de la modernización y aportan evidencias para la auditoría energética y la propuesta al cliente."
  },
  E20500: {
    topic: "Configuración de la línea base",
    content_1_M:
      "Seleccione la ruta de datos de línea base disponible: la Ruta A utiliza información de carga de calefacción, mientras que la Ruta B utiliza datos de consumo de energía. A continuación, defina los meses de funcionamiento y los precios o tarifas energéticas aplicables.",
    content_2_M: "La ruta seleccionada determina cómo se desarrolla la línea base mensual de calefacción y cómo se evalúan los costes energéticos anuales y los ahorros."
  },
  E20610: {
    topic: "Línea base mensual",
    content_1_M:
      "Añada o edite el perfil operativo mensual representativo utilizado para establecer la línea base de calefacción y estimar las condiciones de funcionamiento de los meses restantes del año.",
    content_2_M: "Un perfil operativo representativo proporciona una base coherente para estimar la demanda anual de calefacción, el consumo de energía y los ahorros de la modernización."
  },
  E20611: {
    topic: "Calendario de funcionamiento",
    content_1_M:
      "Defina los días de funcionamiento del sistema, por ejemplo, días laborables, fines de semana o toda la semana. iECM Spec Builder calcula después el número correspondiente de días de funcionamiento de cada mes.",
    content_2_M:
      "Los días de funcionamiento determinan la frecuencia con la que opera el sistema de calefacción y son un dato clave para calcular la carga, el consumo de energía y los ahorros mensuales y anuales."
  },
  E20612: {
    topic: "Horas de funcionamiento",
    content_1_M: "Introduzca las horas diarias de funcionamiento en periodos punta y valle de cada mes, según el horario real del cliente.",
    content_2_M: "Esto asigna el funcionamiento de la calefacción a los periodos y condiciones meteorológicas correctos, mejorando la precisión de los cálculos de carga, consumo y coste."
  },
  E20613: {
    topic: "Funcionamiento de las calderas",
    content_1_M:
      "Seleccione la caldera existente u otro equipo de calefacción que funcione durante los periodos punta y valle. A continuación, confirme los parámetros de funcionamiento y los datos de rendimiento aplicables.",
    content_2_M: "Esto vincula el equipo existente con la demanda mensual de calefacción, lo que permite a iECM Spec Builder estimar el funcionamiento de referencia y el consumo de energía."
  },
  E20615: {
    topic: "Carga mensual de calefacción",
    content_1_M:
      "Revise la carga media de calefacción de los periodos punta y valle de cada mes. El mes representativo se basa en el perfil de carga introducido, mientras que iECM Spec Builder estima los demás meses.",
    content_2_M:
      "El perfil de carga mensual define la línea base de demanda de calefacción utilizada para determinar el funcionamiento de los equipos, calcular el uso de energía y comparar las soluciones de modernización."
  },
  E20616: {
    topic: "Número mensual de calderas",
    content_1_M:
      "Revise el número mínimo de calderas o unidades de calefacción existentes requerido durante los periodos punta y valle de cada mes, según la carga de calefacción y la capacidad disponible.",
    content_2_M: "El número de equipos muestra cómo el sistema existente cubre la demanda mensual y sirve de apoyo al cálculo energético de referencia."
  },
  E20617: {
    topic: "Consumo mensual de energía",
    content_1_M:
      "Revise el consumo mensual de energía estimado para los periodos punta y valle. La estimación se basa en la carga de calefacción, el funcionamiento y el rendimiento de los equipos existentes.",
    content_2_M:
      "Esto establece la línea base energética previa a la modernización utilizada para calcular los costes energéticos anuales y comparar los ahorros ofrecidos por las soluciones propuestas."
  },
  E20623: {
    topic: "Funcionamiento de las calderas",
    content_1_M:
      "Seleccione la caldera existente u otro equipo de calefacción asociado al consumo de energía declarado. A continuación, confirme los parámetros de funcionamiento y los datos de rendimiento aplicables.",
    content_2_M: "Esto vincula la línea base de consumo de energía con el equipo de calefacción real y permite convertir el uso de energía en demanda de calefacción y requisitos operativos."
  },
  E20627: {
    topic: "Consumo mensual de energía",
    content_1_M: "Introduzca o revise el consumo mensual de energía de calefacción del cliente y, cuando corresponda, su distribución entre periodos punta y valle.",
    content_2_M:
      "Los datos de consumo constituyen la principal entrada de la línea base para estimar la demanda mensual de calefacción, los costes energéticos actuales y los ahorros de la modernización."
  },
  E20626: {
    topic: "Número mensual de calderas",
    content_1_M: "Revise el número estimado de calderas o unidades de calefacción existentes requerido durante los periodos punta y valle de cada mes.",
    content_2_M: "Esto muestra cómo se espera que funcionen los equipos existentes para satisfacer la demanda derivada de la línea base de consumo de energía."
  },
  E20625: {
    topic: "Carga mensual de calefacción",
    content_1_M: "Revise la carga mensual de calefacción estimada a partir de los datos de consumo de energía, el perfil operativo y el rendimiento de los equipos existentes.",
    content_2_M: "El perfil de carga derivado proporciona una base común para la demanda de calefacción, lo que permite dimensionar y comparar las soluciones de modernización propuestas."
  },
  E20700: {
    topic: "Vista previa de la línea base",
    content_1_M:
      "Revise los resultados de la línea base, incluidos la demanda mensual de calefacción, el consumo de energía y los costes energéticos. A continuación, descargue el informe de auditoría energética de referencia.",
    content_2_M: "Esto permite verificar el caso de referencia previo a la modernización antes de continuar con el análisis de los equipos y las soluciones propuestas."
  },
  E20800: {
    topic: "Configurar las condiciones de funcionamiento",
    content_1_M:
      "Seleccione el tipo de bomba de calor propuesto y defina las condiciones de funcionamiento posteriores a la modernización, incluidas, cuando corresponda, las temperaturas del lado de la carga y del lado de la fuente.",
    content_2_M:
      "Las condiciones de funcionamiento determinan la capacidad y la eficiencia de la bomba de calor, por lo que son datos esenciales para calcular con precisión el rendimiento del sistema propuesto."
  },
  E20900: {
    topic: "Definir nuevos equipos",
    content_1_M: "Añada las opciones de bombas de calor propuestas y defina las especificaciones principales de cada unidad.",
    content_2_M:
      "Cada opción de equipo se define una sola vez para que iECM Spec Builder pueda determinar el número de unidades necesario y evaluar el rendimiento, los ahorros, la inversión y el retorno financiero."
  },
  E20901: {
    topic: "Selección de bomba de calor: digital e-CAT",
    content_1_M: "Seleccione una bomba de calor en digital e-CAT, defina las condiciones de diseño y el precio de venta de la unidad, y revise los datos de rendimiento disponibles.",
    content_2_M:
      "digital e-CAT proporciona datos coherentes de selección y rendimiento para el análisis de la modernización, mientras que el precio de venta contribuye a estimar el gasto de capital del proyecto (CAPEX)."
  },
  E20902: {
    topic: "Selección de bomba de calor: diseño manual y agrupación de meses",
    content_1_M:
      "Utilice Diseño manual cuando la bomba de calor requerida no esté disponible en digital e-CAT. Agrupe los meses con condiciones de funcionamiento similares y, a continuación, introduzca los datos de equipo y rendimiento de cada grupo.",
    content_2_M:
      "La agrupación de meses reduce la introducción repetida de datos y permite evaluar equipos personalizados en condiciones representativas durante todo el año. El precio de venta contribuye a estimar el gasto de capital (CAPEX)."
  },
  E21000: {
    topic: "Soluciones de modernización",
    content_1_M:
      "Revise las soluciones generadas por iECM Spec Builder y compárelas o clasifíquelas por eficiencia, retorno financiero o inversión. Complete la configuración requerida y genere el informe ECM. También puede reconfigurar una solución manualmente.",
    content_2_M: "Esto ayuda a identificar una propuesta adecuada para el cliente, perfeccionar la configuración de equipos y las hipótesis financieras, y generar el informe final de modernización."
  },
  E22000: {
    topic: "Solución reconfigurada",
    content_1_M:
      "Configure manualmente una solución de modernización seleccionando los equipos propuestos y estableciendo el número máximo de unidades que pueden funcionar durante cada mes de referencia y periodo operativo.",
    content_2_M: "Esto ofrece flexibilidad para crear una configuración específica para el cliente cuando una solución generada automáticamente no satisface plenamente las necesidades del proyecto."
  },
  E21001: {
    topic: "Configuración de la modernización",
    content_1_M:
      "Revise la configuración detallada de la solución, incluidos la carga máxima de calefacción, la capacidad de las bombas de calor propuestas y el número mensual de equipos en funcionamiento.",
    content_2_M: "Esto confirma que el sistema propuesto está correctamente dimensionado y configurado antes de completar la evaluación financiera y el informe final."
  },
  E21002: {
    topic: "ROI y NPV",
    content_1_M:
      "Revise y actualice los resultados financieros del ciclo de vida, incluidos los ahorros de energía y costes, el coste de inversión, el retorno de la inversión (ROI), el periodo de recuperación y el valor presente neto (NPV).",
    content_2_M:
      "Esto demuestra el potencial de la solución para reducir los costes operativos y generar valor financiero a largo plazo, ayudando a los clientes a tomar decisiones de inversión informadas."
  },
  E21004: {
    topic: "Detalles de los equipos propuestos",
    content_1_M: "Defina el alcance detallado de la modernización identificando qué equipos existentes se conservarán y qué equipos propuestos se añadirán o utilizarán como sustitución.",
    content_2_M: "Esto documenta claramente los cambios de equipos y facilita la preparación de un plan de modernización completo, listo para el cliente, y del informe ECM."
  },
  // wizard mode related
  E13000: {
    topic: "Configuración rápida",
    content_1_M:
      "La configuración rápida recopila la información clave del proyecto, de los equipos existentes y de los equipos propuestos necesaria para crear una línea base inicial y un modelo de modernización.",
    content_2_M:
      "Permite que iECM realice una evaluación preliminar con datos limitados del sitio. iECM utiliza los datos proporcionados y los modelos de referencia para generar hipótesis iniciales, que pueden revisarse y ajustarse antes del cálculo."
  },
  E13001: {
    topic: "Revisar hipótesis",
    content_1_M:
      "Introduzca los datos mínimos necesarios, incluidos el sector del edificio, la ruta estimada, la enfriadora del sitio, la enfriadora de referencia, la enfriadora propuesta y la tarifa mensual.",
    content_2_M: "Junto con las hipótesis automatizadas y los valores predeterminados, esto permite realizar cálculos y generar informes rápidamente."
  },
  E13002: {
    topic: "Resultados de la evaluación",
    content_1_M:
      "Introduzca los datos mínimos necesarios, incluidos el sector del edificio, la ruta estimada, la enfriadora del sitio, la enfriadora de referencia, la enfriadora propuesta y la tarifa mensual.",
    content_2_M: "Junto con las hipótesis automatizadas y los valores predeterminados, esto permite realizar cálculos y generar informes rápidamente."
  }
}



// WEBPACK FOOTER //
// ./src/locale/explan/es.js